<template lang="pug">    
  modal(v-show="isShowModal",:titulo="'CAMBIO DE PASSWORD'" bindClass="col-md-4 col-sm-12" , @close="isShowModal=false")
            div(slot='body') 
                .form-group
                    .form-row
                        .col-md-12.col-sm-12
                            label PASSWORD NUEVO
                            input.form-control.form-control-sm(v-model="parameter.NewPassword", type="password", @keypress.enter="sendInfo()") 
                    .form-row
                        .col-md-12.col-sm-12
                            label REPITA PASSWORD
                            input.form-control.form-control-sm(v-model="parameter.CheckNewPassword", type="password", @keypress.enter="sendInfo()")
            div(slot='footer')                      
                button.btn.btn-primary(@click="sendInfo()") CAMBIAR
</template>
<script>
import apiWeb from "../../api/apiSLC.js"
import modal from "../../complementos/modal.vue"
import model from "../../models/users.js"
import SHA3 from 'crypto-js/sha512';
export default {
data(){
    return { 
      isShowModal:true,
      parameter:Object.assign({}, model.parameterResetPassword),
    }
  },
  components:{
    modal
  },
  created()
  { 
  },
  methods : { 
        sendInfo(){
                if(this.validate()){
                    this.Reset()
                }         
        },
        validate(){
            if(this.parameter.NewPassword=='' || this.parameter.NewPassword==null ){
                this.$msgbox.show("Ingrese Nuevo Password","Alerta")
                return false
            } 
            else if(this.parameter.CheckNewPassword=='' || this.parameter.CheckNewPassword==null ){
                this.$msgbox.show("Ingrese Password para Confirmar","Alerta")
                return false
            }
            else if(this.parameter.CheckNewPassword!=this.parameter.NewPassword ){
                this.$msgbox.show("Los Password no Coinciden","Alerta")
                return false
            } 
            else{
                return true
            }
        },
        Reset(){  
            this.parameter.IdUser=this.$info.idUser
            this.parameter.User=this.$info.email
            this.parameter.IP=this.$info.ip
            this.parameter.NewPassword=SHA3(this.parameter.NewPassword).toString()
            apiWeb.post("users/users_Reset",this.parameter)
                    .then(result=>{ 
                             if(result.status==0){ 
                                this.isShowModal=false
                                this.$router.push({path:'/'} )
                                this.$msgbox.show("Password Cambiada","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
  }
}
</script>